import { Box, Button, FormControl, FormErrorMessage, FormLabel, Heading, Input, Stack, useColorModeValue } from '@chakra-ui/react';
import { Form, Formik, useFormik } from 'formik';
import { useNavigate } from 'react-router-dom';

import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import ModalLoading from '../../../components/Loader/ModalLoader.jsx';
import { urlNavigate } from '../../../helper/utils/navigation.js';
import { doSetPassword } from '../../../redux/waiver/waiver.actions.js';
import FormLayoutProvider from '../../layout/FormLayoutProvider.jsx';

export default function AuthSetPassword() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const { otp = '', loadingRegister = false } = useSelector((s) => s?.waiver);

    const formik = useFormik({
        initialValues: {
            password: '',
        },
        onSubmit: (values) => dispatch(doSetPassword({ ...values, otp }, navigate)),
    });

    return (
        <FormLayoutProvider>
            <ModalLoading loading={loadingRegister} />
            <Stack spacing={8} mx={'auto'} maxW={'lg'} py={12}>
                <Stack align={'center'}>
                    <Heading fontSize={'xl'}>Create Password</Heading>
                </Stack>
                <Box rounded={'lg'} bg={useColorModeValue('white', 'gray.700')} boxShadow={'lg'} p={8}>
                    <Stack spacing={4}>
                        <Formik onSubmit={formik.handleSubmit} initialValues={formik.initialValues}>
                            <Form>
                                <FormControl isRequired id='password' isInvalid={!!formik?.errors.password && formik?.touched.password}>
                                    <FormLabel>Password</FormLabel>
                                    <Input type='password' size='lg' id='password' name='password' onChange={formik.handleChange} value={formik?.values?.password ?? ''} placeholder={t('please_fill_password')} />
                                    <FormErrorMessage>{formik?.errors.password}</FormErrorMessage>
                                </FormControl>

                                <Stack spacing={4} my={8}>
                                    <Button
                                        type='submit'
                                        bg={'teal.400'}
                                        color={'white'}
                                        _hover={{
                                            bg: 'teal.500',
                                        }}>
                                        {t('register')}
                                    </Button>

                                    <Button onClick={() => navigate(urlNavigate('online-sales', 'home'))}>{t('fill_waiver')}</Button>
                                </Stack>
                            </Form>
                        </Formik>
                    </Stack>
                </Box>
            </Stack>
        </FormLayoutProvider>
    );
}
